






































































































import { Component, Vue, PropSync } from "vue-property-decorator";
import uuid from "uuid/v4";
import { State, Getter } from "vuex-class";
import { Profile } from "@foxone/api/src/models/hfox/account";
import { USDT_ASSET } from "hfox/constants";
import { CONFIGS } from "@/constants";

const SWAP_PUSD_URL = `${CONFIGS.SWAP_URL}swap?input=4d8c508b-91c5-375b-92b0-ee702ed2dac5&output=31d2ea9c-95eb-3355-b65b-ba096853bc18`;

const EXIN_LOCAL_URL =
  "https://hk.exinlocal.com/#/exchange?side=sell&uuid=31d2ea9c-95eb-3355-b65b-ba096853bc18";

@Component
class DepositModal extends Vue {
  @PropSync("visible") dialog!: boolean;

  @State(state => state.hfox.profile) profile!: Profile;

  @Getter("wallet/mixin/getAssetById") getAssetById;

  amount = "";

  submitting = false;

  loading = false;

  get meta() {
    const quicks = [10, 50, 100, 500, 1000];
    const usdt = {
      ...USDT_ASSET,
      chainLogo: this.$common.utils.helper.getChainLogo(this, USDT_ASSET)
    };
    const legalAmount = this.$common.utils.currency.fiat(this, {
      from: "USD",
      value: this.amount
    });
    const asset = this.getAssetById(USDT_ASSET.id);
    const balance = asset?.balance;
    const valid = Number(this.amount) > 0;
    return {
      quicks,
      usdt,
      valid,
      balance,
      legalAmountText: legalAmount && `≈${legalAmount}`,
      assets: [usdt]
    };
  }

  showDepositMessage() {
    this.$helper.message(
      this,
      {
        title: this.$t("hfox.deposit-confirm") as string,
        description: this.$t("hfox.deposit-confirm-descript") as string,
        ok: this.$t("hfox.deposit.confirm-paid") as string,
        okColor: "primary"
      },
      {
        onOK: () => {
          this.dialog = false;
          this.$emit("refresh");
        }
      }
    );
  }

  async handleUsdtDeposit() {
    this.loading = true;
    try {
      const res = await this.$api.hfox.getDepositMemo();
      const data = {
        memo: res.memo,
        amount: this.amount,
        assetId: this.meta.usdt.id,
        traceId: uuid(),
        recipient: this.profile.wallet_id
      };
      this.showDepositMessage();
      const url = this.$common.utils.helper.genPayment(data);
      window.location.href = url;
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }

  handleToOTC() {
    window.location.href = EXIN_LOCAL_URL;
  }

  handleToSwap() {
    window.location.href = SWAP_PUSD_URL;
  }

  handleFillBalance() {
    this.amount = this.meta.balance;
  }

  // Deprecated
  handleFiatDeposit() {
    const config = this.$store.state.app.config;
    if (config.c2c) {
      const walletId = this.$store.state.hfox.profile.wallet_id;
      if (!walletId) {
        return;
      }
      this.$common.utils.helper.toFusionPath(this, "trade", {
        name: "fiat-hfox",
        query: {
          wantedAmount: this.amount
        }
      });
    } else {
      window.location.href = this.$common.configs.OTC_URL;
    }
  }

  handleQuickFill(v) {
    this.amount = v;
  }
}
export default DepositModal;
